import BaseVirtualLineForm from "./base_virtual_line_form";

export default class NewVirtualLineForm extends BaseVirtualLineForm {
  initialize(options) {
    super.initialize(options);

    this.config = options.config;

    if (!this.model) {
      throw new Error("model must be provided");
    }
    this.templateConfig = {
      displayPromoType: true,
      manageVirtualLines: this.config.manageVirtualLines,
      defaultAdwordsAccount: this.defaultAdwordsAccount(this.config.availableAccounts)
    };
  }
}
